import i18n from '@/i18n'
import {makeStep} from "../../utils";
import {requireAssetWithFallback} from "@/utils";

const supportType = (curtainTemplate, curtainType, color) => {
  //get from api available support types
  //at this moment is not available
  // const availableColors = curtainTemplate.available_support_types
  const availableTypes = ['wall', 'ceiling']

  if (
    curtainType !== "pleatcurtain"
    || !availableTypes
    || !availableTypes.length
  ) {
    return null
  }
  return {
    id: 'support_type',
    name: i18n.t("components.stepper.supportType.title"),
    type: 'card',
    choices: availableTypes.map(availableType => ({
      title: i18n.t(`enums.SupportType.${availableType}`),
      value: availableType,
      imgSrc: requireAssetWithFallback(`images/rail_rod/trackrail/support_type/${availableType}/${color}.png`),
    }))
  }
}

export default (curtainTemplate, curtainType, color) => {
  const stepQuestions = [
    supportType(curtainTemplate, curtainType, color),
  ]
  return makeStep(stepQuestions, i18n.t("components.stepper.supportType.title"))
}
